/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSignRight = createReactComponent("outline", "sign-right", "IconSignRight", [["path", { "d": "M8 21h4", "key": "svg-0" }], ["path", { "d": "M10 21v-10", "key": "svg-1" }], ["path", { "d": "M10 6v-3", "key": "svg-2" }], ["path", { "d": "M6 6h10l2 2.5l-2 2.5h-10z", "key": "svg-3" }]]);

export { IconSignRight as default };
//# sourceMappingURL=IconSignRight.mjs.map
